/** Prospective method classification only; historical Sales use sale.on_account. */
export const DEFERRED_SETTLEMENT_TYPES: ReadonlySet<string> = new Set([
  "on_account", "receivable", "deferred",
]);

export function isDeferredSettlement(type?: string | null): boolean {
  return typeof type === "string" && DEFERRED_SETTLEMENT_TYPES.has(type);
}
